module.exports = __webpack_public_path__ + "static/media/level_0.14af53ac.svg";